/**** mgt.Vehicle */

const config = {
  schema: 'mgt',
  table: 'Vehicle',
  title: 'Транспортные средства',
  elemsOnPage: 10,
  connections: {
    transporttype: {
      schema: 'mgt',
      table: 'TransportType',
      index: 'note',
      fields: ['title'],
      format: (elem: any) => elem['title'],
    },
    depots: {
      schema: 'mgt',
      table: 'Depot',
      index: 'depot_id',
      fields: ['depot_name'],
      format: (elem: any) => elem['depot_name'],
      autocomplete: false,
    },
    capacitytype: {
      schema: 'cat',
      table: 'CapacityType',
      index: 'id',
      fields: ['title'],
      format: (elem: any) => elem['title'],
    },
  },
  fields: [
    {
      name: 'vehicle_id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
      hide: true,
    },
    {
      name: 'route_type',
      title: 'Тип ТС',
      type: 'text',
      required: true,
      connection: 'transporttype',
    },
    {
      name: 'vin',
      title: 'VIN-номер',
      type: 'text',
      required: false,
    },
    {
      name: 'model',
      title: 'Марка/Модель',
      type: 'text',
      required: false,
    },
    {
      name: 'gos_nomer',
      title: 'ГРЗ',
      type: 'text',
      required: false,
    },
    {
      name: 'depot_id',
      title: 'Филиал',
      type: 'text',
      required: false,
      connection: 'depots',
      link: 'park'
    },
    {
      name: 'depot_number',
      title: 'Гаражный номер',
      type: 'number',
      required: true,
    },
    {
      name: 'capacity_id',
      title: 'Вместимость',
      type: 'text',
      required: false,
      connection: 'capacitytype',
    },
  ],
  defaultSort: {
    field: 'vehicle_id',
    direction: 'desc',
  },
  makeTitle: (elem: any, connections: { [key: string]: any }): string => {
    return `${elem['depot_number']} (${elem['gos_nomer'] || '-'})`;
  },
  makeAdditional: (elem: any, connections: { [key: string]: any }): string => {
    const tt =
      connections &&
      connections['transporttype'] &&
      connections['transporttype'].find(
        (tp: any) => tp['note'] === elem['route_type']
      );
    const cp =
      connections &&
      connections['capacitytype'] &&
      connections['capacitytype'].find(
        (c: any) => c['id'] === elem['capacity_id']
      );
    return `VIN: ${elem['vin']}; Модель: ${elem['model']}; Тип: ${(tt &&
      tt['title']) ||
      '-'}; Вместимость: ${(cp && cp['title']) || '-'}`;
  },
};

export default config;
